<template>
  <v-app-bar app>
    <v-breadcrumbs :items="['Behavior & Profile Tracker']" />
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
